import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Quotation from "../../entity/insurance/Quotation";

const SERVICE = "service-insurance";
const ENTITY = "quotations";

export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Quotation(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application");
                }
            }
        },
        findOneByInterventionId(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.find(q => q?.getInterventionId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "intervention_id", id, newInstance, "application");
                }
            }
        },
        async updateVat(id, payload) {
            return update(SERVICE, ENTITY, id, "vat", payload, newInstance, "application");
        }
    }
}
